/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react';
import { ButtonBase } from '@mui/material';
import { SetStateAction, Dispatch } from 'react';
import MultiStarsIcon from '../../../icons/icons-revamp/multi_stars_icon';
import { QSTypography } from '../../atoms';
import { CANNY_CHANGELOG_URL } from '../../header/constant';
import Link from '../../atoms/Link';

const rotateAngle = keyframes`
  from { --angle: 0deg; }
  to { --angle: 360deg; }
`;

const collapsedBtnCss = css`
  width: 36px;
  height: 36px;
  min-height: 36px;
  min-width: 36px;
  background: #fff;
  border: 1px solid #e0e0ea;
  transition-duration: 0.5s;
  overflow: hidden;
  white-space: nowrap;
  border-radius: 4px;
`;

const expandedBtnCss = css`
  border-radius: 4px;
  @property --angle {
    syntax: '<angle>';
    initial-value: 0deg;
    inherits: false;
  }
  animation: ${rotateAngle} 3s linear infinite;
`;

const whatsNewTextCss = css({
  marginLeft: '6px',
  fontSize: '14px',
  color: '#2d2d2d',
  fontFamily: 'Inter',
  fontWeight: '600',
});

const WhatsNewBtn = ({
  expand,
  setIsHoveringOverWhatsNewButton,
}: {
  expand: boolean;
  setIsHoveringOverWhatsNewButton: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <Link href={CANNY_CHANGELOG_URL} target="_blank">
      <ButtonBase
        onMouseEnter={() => setIsHoveringOverWhatsNewButton(true)}
        onMouseLeave={() => setIsHoveringOverWhatsNewButton(false)}
        className={expand ? 'whats-new-button' : ''}
        css={expand ? expandedBtnCss : collapsedBtnCss}
      >
        <MultiStarsIcon />
        <QSTypography className={'whats-new-button-text ' + (expand ? 'expanded' : 'collapsed')} css={whatsNewTextCss}>
          What's New
        </QSTypography>
      </ButtonBase>
    </Link>
  );
};

export default WhatsNewBtn;
